// systemWifiApi.js
import http from "../../http-common";

const API_BASE = "/api/system";

const wifiApi = {
  getInfo: () => http.get(`${API_BASE}/internet-info`),
  refresh: () => http.post(`${API_BASE}/refresh-connection`),
  connect: (ssid) =>
    http.post(`${API_BASE}/connect-to-specific-network`, { ssid }),
  add: (ssid, password) =>
    http.post(`${API_BASE}/add-internet-connection`, { ssid, password }),
  update: (ssid, password) =>
    http.put(`${API_BASE}/update-internet-connection`, { ssid, password }),
  remove: (ssid) =>
    http.delete(`${API_BASE}/delete-internet-connection`, { data: { ssid } }),
  getServerInternetSpeed: () => http.get(`${API_BASE}/server-internet-speed`),
  pingTest: () => http.get(`${API_BASE}/ping-test`),
};

export default wifiApi;
